import React from 'react';
import Folder from '../Folder';
import { StyledContainerFolder } from './styles';
import { useCallback, useMemo } from 'react';

import Breadcrumb from '../Breadcrumb/index';

import FilesContainer from '../FilesContainer/index';
import Skeleton from 'react-loading-skeleton';

export default function FoldersContainer({
  documentsFolders,
  documentsList,
  selectedPaths,
  setSelectedPaths,
  loadMoreFiles,
  loadFolderFiles,
  currentPath,
  onOpenFile,
}) {
  const hasAnyPathSelected = useMemo(() => {
    return selectedPaths.length > 1;
  }, [selectedPaths]);

  const foldersToRender = useMemo(() => {
    if (hasAnyPathSelected) {
      const foundedDocument = documentsFolders.find(
        (folder) => folder.nome === currentPath
      );

      const subfolders = foundedDocument?.subPastas;

      return subfolders;
    }

    return documentsFolders;
  }, [documentsFolders, hasAnyPathSelected, currentPath]);

  function handleBack() {
    const updatedSelectedFolders = selectedPaths.slice(
      0,
      selectedPaths.length - 1
    );
    const previousFolder = [...updatedSelectedFolders];

    setSelectedPaths(previousFolder);
  }

  const selectPath = useCallback(
    (path) => {
      let paths = [...selectedPaths];

      const index = paths.indexOf(path);

      if (index !== -1) {
        paths = paths.slice(0, index + 1);
      } else {
        paths.push(path);
      }

      setSelectedPaths(paths);
    },
    [selectedPaths, setSelectedPaths]
  );

  return (
    <StyledContainerFolder>
      {hasAnyPathSelected && (
        <Breadcrumb
          paths={selectedPaths}
          handleBack={handleBack}
          selectPath={selectPath}
          currentPath={currentPath}
        />
      )}

      {!hasAnyPathSelected &&
        (!foldersToRender || foldersToRender?.length < 1) && (
          <Skeleton
            containerClassName='skeletonFolders'
            count={6}
            width={'calc((100% / 4) - 16px)'}
            height={56}
            borderRadius={8}
          />
        )}

      {foldersToRender && foldersToRender?.length > 0 && (
        <div className='folders'>
          {foldersToRender.map((folder) => (
            <Folder
              key={folder.id}
              onButtonClick={() => selectPath(folder)}
              folderName={folder.nome}
              variant={hasAnyPathSelected ? 'list' : 'default'}
              style={{
                marginRight: 16,
                marginBottom: hasAnyPathSelected ? 0 : 16,
              }}
            />
          ))}
        </div>
      )}

      {hasAnyPathSelected &&
        (!foldersToRender || foldersToRender?.length < 1) && (
          <FilesContainer
            files={documentsList?.filesFounded}
            maxPages={documentsList?.qtdDePaginas}
            qntFiles={documentsList?.itensQtdTotal}
            currentPage={documentsList?.pagina}
            loadMoreFiles={loadMoreFiles}
            loadFolderFiles={loadFolderFiles}
            onOpenFile={onOpenFile}
          />
        )}
    </StyledContainerFolder>
  );
}
